import { ENABLE_OTA_LOGS } from "../constants/logging";

let otaApplying = false;

export const setOtaApplying = (value: boolean) => {
  otaApplying = value;
  if (ENABLE_OTA_LOGS) {
    // eslint-disable-next-line no-console
    console.log("[OTA] setOtaApplying", value);
  }
};

export const isOtaApplying = () => otaApplying;
